import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import Select from "react-select";
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";


import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';

import Pagination from '../Pagination/Paginations.js';
import EntriesSelector from '../Pagination/EntriesSelector';
import useSortData from "../Pagination/SortData";



import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';

// import DataTable from 'datatables.net-react';
// import DT from 'datatables.net-dt';

// DataTable.use(DT);
import {
	statisticsAction,
	statisticsCloseAction
} from '../../actions/settingsAction.js';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
const ListLeaves = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;
	
	 const [toggle,setToggle]=useState(false);
	const today = new Date().toISOString().split("T")[0];


	const [user, setUser] = useState({
        exchange_date:"",
		
    })


    const [exchangeshift, setExchangeShift] = useState({
  department: "",
  exchange_from: "",
  exchange_to: "",
  exchange_shift_date: "",
});


const handleExchangeInput = (e) => {
  const { name, value } = e.target;
  setExchangeShift((prev) => ({ ...prev, [name]: value }));
};



useEffect(() => {
  if (exchangeshift.department) {
    fetch(`${API_BASE_URL}/showdeptbaseemp/${exchangeshift.department}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    })
      .then((res) => res.json())
      .then((data) => setEmployeeDropdownOptions(data))
      .catch((err) => console.error("Error fetching employees:", err));
  }
}, [exchangeshift.department]);



	

	
	const history = useHistory();
	const [data, setData]= useState([]);
	const [dataval, setdataval]= useState([]);
    const [isVisible, setIsVisible] = useState(false);
	const [urlres, setUrlRes] = useState(false);
	const [style1,setStyle1]=useState(false);
	const [records, setRecords] = useState([]);
	const [loading, setLoading] = useState(false);
	const { sortConfig, sortData, handleSort } = useSortData();


    const handelInput = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        console.log(name, value)
        setUser({ ...user, [name]: value });

        if (event.target.value === '1') {
            setIsVisible(true);
          } else {
            setIsVisible(false);
          }
    }


		const [searchTerm, setSearchTerm] = useState("");
		const [currentPage, setCurrentPage] = useState(1);
		const [entriesPerPage,setEntriesPerPage]=useState(10);
		let filteredItems = records.filter((item) =>
			`${item.shift_date.toLowerCase()}${item.from_emp.toLowerCase()}${item.to_emp.toLowerCase()}`.includes(searchTerm.toLowerCase())
		 
		);
		const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
		const indexOfLast = currentPage * entriesPerPage;
		const indexOfFirst = indexOfLast - entriesPerPage;
		// const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);
		const sortedItems = sortData(filteredItems);
		const filteredData = sortedItems.slice(indexOfFirst, indexOfLast);

		const startIndex = (currentPage - 1) * entriesPerPage;
	  
		useEffect(() => {
		  setCurrentPage(1);
		}, [searchTerm]);
	  
		
	
	  const handleSearch = (event) => {
		//console.log(event.target.value);
		 setSearchTerm(event.target.value);
	  };
	
	



	    const handleDepartment = async () => {
	  
			axios.get(API_BASE_URL +'/dept_list_under_incharge/', {
            headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
        })
			.then(res1 => setdataval(res1.data))
			.catch(err => console.log(err))
		   };
	  
	  
		   useEffect(() => {
			handleDepartment();
		  }, []);


 const [department, setDepartmentValue] = useState("ALL");
 const [employeeDropdownOptions,setEmployeeDropdownOptions]=useState([]);
 const [employeedet,setEmployeeValue] = useState("ALL");


 const handleFirstDropdownChange = (event) => {
    const value = event.target.value;
    setDepartmentValue(value);

    // Trigger API call based on the selected value
    fetchSecondDropdownOptions(value);
  };


     // Fetch options for the second dropdown
     const fetchSecondDropdownOptions = async (selectedValue) => {

      try {
      
    const response = await fetch(
          API_BASE_URL + '/showdeptbaseemp/'+selectedValue, {
            headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
        }
        ); // Replace with your API URL
  
        const data = await response.json();
        console.log(data);

        setEmployeeDropdownOptions(data); // Assuming the API returns an array of options
      } catch (error) {
        console.error("Error fetching second dropdown options:", error);
      }
    };


      // Handle second dropdown change
      const handleSecondDropdownChange = (event) => {
        // setSecondDropdownValue(event.target.value);
        setEmployeeValue(event.target.value);
      };





  useEffect(()=> {
	axios.get(API_BASE_URL +'/fetchshift', {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	})

	//.then(res =>console.log(res.data))
	 .then(res => setData(res.data))
	.catch(err => console.log(err));
},[])




const handleExchangeSubmit = async (e) => {
  e.preventDefault();

  const { department, exchange_from, exchange_to, exchange_shift_date } = exchangeshift;


// alert( department+', '+exchange_from+', '+exchange_to+', '+exchange_shift_date);
 

  if (!department || !exchange_from || !exchange_to || !exchange_shift_date) {
    toast.error("Please fill all required fields!", {
						position: "bottom-right",
						autoClose: 5000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
						theme: "colored",
	  
					});
    return;
  }

  try {
    const res = await axios.post(
      `${API_BASE_URL}/process_shift_exchange`,
      {
        department_id: department,
        employee_from_id:exchange_from,
        employee_to_id:exchange_to,
        shift_date: exchange_shift_date,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          "Content-Type": "application/json",
        },
      }
    );

    var status = res.data.status;

  if (status=='success')
  {
  toast.success(res.data.message, {
			position: "bottom-right",
			autoClose: 5000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
			theme: "colored",
			});
			const timeout = setTimeout(() => {
					window.location.reload(); // Reload the current page
				}, 5000); // Refresh after 5 seconds
  
				return () => {
					clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				};

  setExchangeShift({
    department: "",
    exchange_from: "",
    exchange_to: "",
    exchange_shift_date: "",
  });
}else {
     toast.error(res.data.message, {
						position: "bottom-right",
						autoClose: 5000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
						theme: "colored",
	 
					});
    }
  } catch (err) {
    console.error("Error submitting exchange shift:", err);
    toast.error("Something went wrong!");
  }
};






const handleSubmit = async (e) => {
    e.preventDefault();
	setLoading(true);
    try {
      const response = await axios.post(API_BASE_URL +'/incharge_shift_exchange',
		{ exchange_date: user.exchange_date}, 
		{
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}

);
//  console.log(response.data.exchange_shift);
      setRecords(response.data.exchange_shift); // Assuming the API response contains the records in `response.data`
	  setLoading(false);
	} catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  useEffect(()=> {
	axios.post(API_BASE_URL +'/incharge_shift_exchange',{ exchange_date: user.exchange_date }, {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	})

	//  .then(response =>console.log(response))
	 .then(response => setRecords(response.data.exchange_shift))
	.catch(err => console.log(err));
},[])




const columns = [
  { label: "From Employee", key: "from_emp", sortable: true },
  { label: "To Employee", key: "to_emp", sortable: true },
  { label: "Shift Date", key: "shift_date", sortable: true },
  { label: "Shift From", key: "shift_from", sortable: true },
  { label: "Shift To", key: "shift_to", sortable: true },
  { label: "Request On", key: "request_on", sortable: true },
  { label: "Hr Approval", key: "hr_approval_status", sortable: true },
];

	return (
		<>


			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

							<ToastContainer />
						
						</div>
					</div>

                    <div className="section-body mt-3">
										<div className="container-fluid">
											<div className="row clearfix">
												<div className="col-md-12">
                                                <button style={{width:'100px',float: 'right',margin: '10px 35px 15px 10px'}}
                                                            type="button"
                                                            className="btn btn-primary"
                                                            onClick={()=>setToggle(!toggle)}
                                                        >
                                                            <i className="fe fe-plus mr-2" />
                                                            Add
                                                        </button>
                                                        {toggle && (
													<div className="card">
														{/* <div className="card-header">
															<h3 className="card-title">My Shift</h3>
														</div> */}
														<div className="card-body">

                                                      


                                                       


															<form onSubmit={handleExchangeSubmit}>
  <div className="row">
    {/* Department */}
    <div className="col-md-3 col-sm-12">
      <div className="form-group">
        <label className="form-label">
          Department <span className="form-required">*</span>
        </label>
        <select
          className="form-control show-tick"
          name="department"
          value={exchangeshift.department}
          onChange={handleExchangeInput}
        >
          <option value="">Select Department</option>
          {dataval.map((option) => (
            <option key={option.department_id} value={option.department_id}>
              {option.department_name}
            </option>
          ))}
        </select>
      </div>
    </div>

    {/* Exchange From */}
    <div className="col-md-3 col-sm-12">
      <div className="form-group">
        <label className="form-label">
          Exchange From <span className="form-required">*</span>
        </label>
        <select
          className="form-control show-tick"
          name="exchange_from"
          value={exchangeshift.exchange_from}
          onChange={handleExchangeInput}
          disabled={employeeDropdownOptions.length === 0}
        >
          <option value="">Select From Employee</option>
          {employeeDropdownOptions.map((option) => (
            <option key={option.user_id} value={option.user_id}>
              {option.first_name} {option.last_name}
            </option>
          ))}
        </select>
      </div>
    </div>

    {/* Exchange To */}
    <div className="col-md-3 col-sm-12">
      <div className="form-group">
        <label className="form-label">
          Exchange To <span className="form-required">*</span>
        </label>
        <select
          className="form-control show-tick"
          name="exchange_to"
          value={exchangeshift.exchange_to}
          onChange={handleExchangeInput}
          disabled={employeeDropdownOptions.length === 0}
        >
          <option value="">Select To Employee</option>
          {employeeDropdownOptions.map((option) => (
            <option key={option.user_id} value={option.user_id}>
              {option.first_name} {option.last_name}
            </option>
          ))}
        </select>
      </div>
    </div>

    {/* Exchange Date */}
    <div className="col-md-3 col-sm-6">
      <div className="form-group">
        <label className="form-label">
          Exchange Date <span className="form-required">*</span>
        </label>
        <input
          type="date"
          className="form-control"
          name="exchange_shift_date"
          value={exchangeshift.exchange_shift_date}
          onChange={handleExchangeInput}
        />
      </div>
    </div>
  </div>

  <div className="row">
    <div className="col-md-4 col-sm-6">
      <div className="form-group">
        <button type="submit" className="btn btn-primary">
          Submit
        </button>
      </div>
    </div>
  </div>
</form>

                                               
														</div>
													</div>
                                                     )}
												</div>
					
											</div>
										</div>
									</div>


					 <div className="section-body mt-3">
										<div className="container-fluid">
											<div className="row clearfix">
												<div className="col-md-12">
													<div className="card">
														{/* <div className="card-header">
															<h3 className="card-title">My Shift</h3>
														</div> */}
														<div className="card-body">
															 <form onSubmit={handleSubmit} > 
					
																<div class="row">
					
																<div className="col-md-4 col-sm-6">
																	<div className="form-group">
																	<input type="date" className="form-control" name="exchange_date" value={user.exchange_date}
													onChange={handelInput}  />
																
																	</div>
																</div>


                                                                <div className="col-md-4 col-sm-6">
														<div className="form-group">
					
													<button type="submit" className="btn btn-primary">
													GET
												</button>
					
												
												</div>
												</div>
					
																
					
					
													</div>

													
															 </form>
														</div>
													</div>
												</div>
					
											</div>
										</div>
									</div>


										<div className="section-body">
											<div className="container-fluid">
												<div className="tab-content">
													<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
														<div className="card">
					
															<div className="card-header">
																<h3 className="card-title" style={{color:'#e96827'}}>Exchange Shift List</h3>
																<div className="card-options">
																	<form>
																		<div className="input-group">
																		<EntriesSelector style={{
																			padding: '1px',
																			marginRight: '20px',
																			borderRadius: '4px',
																			border: '1px solid #ccc',
																			backgroundColor: '#BCD1DB',display: 'flex', justifyContent: 'left'
																		}}
																		setEntriesPerPage={setEntriesPerPage}
																		setCurrentPage={setCurrentPage}
																		/> 
																		
																			 <input
																				type="text"
																				className="form-control form-control-sm"
																				placeholder="Search"
																				value={searchTerm}
																				onChange={e => {
																setSearchTerm(e.target.value);
																setCurrentPage(1);
																}} style={{ padding: '8px', width: '200px', borderRadius: '4px', border: '1px solid #ccc' }} 
																			/>
																		</div>
																	</form>
																</div>
															</div>
					
															{/* <div>
																<DataTable 
																columns={column} 
																data={data}
																customStyles={customStyles}
																pagination 
																highlightOnHover
																responsive
																paginationPerPage={10}
																paginationRowsPerPageOptions={[25,50,100,500]}
																className="table table-striped table-bordered"> 
															</DataTable>
															</div> */}
					
					
					
					
					
					
					
					{/* Loading Spinner */}
					{loading && (
																<div className="card-body">
																<div class="d-flex justify-content-center">
						   <div class="spinner"></div>
						   </div>
						   </div>
						  )}
					
					{!loading && (
															<div className="card-body">
															
																<div className="table-responsive">
							
					
						
						  
								<table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
																		<thead>
																			<tr>
					
																			   {columns.map((col) => (
																<th
																	key={col.key}
																	onClick={col.sortable ? () => handleSort(col.key) : null}
																	style={{ cursor: col.sortable ? "pointer" : "default" }}
																>
																	{col.label}
																	{col.sortable && (
																sortConfig.key === col.key
																	? (sortConfig.direction === "asc" ? " ▲" : " ▼")
																	: " ⇅"   // <-- DEFAULT SORT ICON
																)}
																	</th>
																))}
																				
																			</tr>
																		</thead>
																		<tbody>
																		{records.length > 0 ? (
																				filteredData.map((record) => (
																					<tr key={record.shift_date}>
																					<td>{record.from_emp}</td>
																					<td>{record.to_emp}</td>
																					<td>{record.shift_date}</td>
																					<td>{record.shift_from}</td>
																					<td>{record.shift_to}</td>
																					<td>{record.request_on}</td>
																					<td>{ReactHtmlParser(record.hr_approval_status)}</td>
																				</tr>
																				))
																			) : (
																				<tr>
																				<td colSpan="7" style={{ color: 'red', textAlign: 'center',fontWeight: "bold" }}>No records found</td>
																				</tr>
																			)}
					
																
																		</tbody>
																	</table>
																</div>
															
												<Pagination
												currentPage={currentPage}
												totalPages={totalPages}
												onPageChange={setCurrentPage}
												/>	
													
					
															</div> 
					)
					}
														</div>
													</div>
						
												
												</div>
											</div>
										</div>

				</div>
			</div>




		</>
	);

}



const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(ListLeaves);